export const START_FETCH = "explorer/START_FETCH";
export const SET_ENTITY = "explorer/SET_ENTITY";
export const SET_ERRORS = "explorer/SET_ERRORS";

export const RESET = "explorer/RESET";
export const CLEAR = "explorer/CLEAR";
export const PUSH = "explorer/PUSH";
export const POP = "explorer/POP";
export const GOTO = "explorer/GOTO";

export const LINK = "explorer/LINK";
export const UNLINK = "explorer/UNLINK";
export const LINK_HARD = "explorer/LINK_HARD";
export const UNLINK_HARD = "explorer/UNLINK_HARD";
export const DELETE_REL = "explorer/DELETE_REL"; // delete related entity

// delete entity
export const DELETE = "explorer/DELETE"; // delete 'hard' - on persistent layer. will also REMOVE, see below.
export const REMOVE = "explorer/REMOVE" // delete from explorer, unlink including attrs from all related entities.

export const SUBMIT = "explorer/SUBMIT";
export const CANCEL = "explorer/CANCEL";

export const SET_FIELD_VALUE = "explorer/SET_FIELD_VALUE";
export const SET_VECTOR_VALUE = "explorer/SET_VECTOR_VALUE";
export const REPLACE_ID = "explorer/REPLACE_ID";

export const SET_MORPH = "explorer/SET_MORPH";
export const SET_SHOW_HIDDEN = "explorer/SET_SHOW_HIDDEN"; // show hidden fields

// complex actions (sagas)
export const CREATE_TEMP = "explorer/CREATE_TEMP";
export const CREATE_NEW = "explorer/CREATE_NEW";
